export class NPFillRateTypeDicoCarac{
  ExtID: string;
  Selected: string;
}
